import { createAction } from '@reduxjs/toolkit';

export const setTurndownInfo = createAction('[Turndown] setTurndownInfo');
export const setTurndownDialogOpen = createAction('[Turndown] setTurndownDialogOpen');
export const turndownETA = createAction('[Turndown] turndownETA');
export const setTurndownTypes = createAction('[Turndown] setTurndownTypes');
export const setTurndownInProgress = createAction('[Turndown] setTurndownInProgress');
export const createComment = createAction('[Turndown] createComment');
